import { render, staticRenderFns } from "./LoaderScoped.vue?vue&type=template&id=1b2368aa&scoped=true&"
import script from "./LoaderScoped.vue?vue&type=script&lang=js&"
export * from "./LoaderScoped.vue?vue&type=script&lang=js&"
import style0 from "./LoaderScoped.vue?vue&type=style&index=0&id=1b2368aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2368aa",
  null
  
)

export default component.exports